import { Button } from '@heroui/react';

export const CartSubmit = ({
  isDisabled = false,
  onPress,
  variant = 'cart',
}: {
  variant?: 'cart' | 'checkout';
  isDisabled?: boolean;
  onPress?: () => void;
}) => {
  const label = { cart: 'Оформить заказ', checkout: 'Оформить заказ' };
  return (
    <Button
      variant="solid"
      size="lg"
      isDisabled={isDisabled}
      fullWidth
      color="primary"
      onPress={onPress}
    >
      {label[variant]}
    </Button>
  );
};
